import mykhailoPhoto from "@assets/image_1773345523383.png";
import { useSEO } from "@/hooks/use-seo";
import { PaymentLogoPill } from "@/components/PaymentLogoPill";
import { useState } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import {
  ArrowRight, Star, CheckCircle, XCircle, ShieldCheck, Gamepad2,
  HeadphonesIcon, Info, Heart, CreditCard, Clock, Mail, MessageCircle,
  Phone, Calendar, Lock, Users, Trophy, Zap, AlertTriangle, Globe,
  Play, Smartphone
} from "lucide-react";
import { Button } from "@/components/ui/button";
import logo17 from "@assets/logos_extracted/17.png";
import { CasinoBreadcrumb } from "@/components/CasinoBreadcrumb";
import { DalsiRecenze } from "@/components/DalsiRecenze";

const CASINO_URL = "https://swp.fynkelto.com/?mid=279656_1645821";

const tabs = [
  { id: "platby",     label: "Platby",              icon: CreditCard },
  { id: "hry",        label: "Hry",                 icon: Gamepad2 },
  { id: "podpora",    label: "Zákaznická podpora",  icon: HeadphonesIcon },
  { id: "obecne",     label: "Obecné informace",    icon: Info },
  { id: "zodpovedne", label: "Zodpovědné hraní",    icon: Heart },
];

const pros = [
  "Unikátní rozhraní s funkcí \u201eShorts\u201c pro snadné procházení her",
  "Více než 9 000 her od více než 100 předních poskytovatelů",
  "Funkce Pay N Play pro rychlý přístup bez registrace",
  "Vícejazyčná podpora 24/7 včetně češtiny",
  "Věrnostní program s VIP výhodami a štědrý uvítací bonus",
];

const cons = [
  "Chybí mobilní aplikace – pouze responzivní web",
  "Maximální měsíční limit pro výběr není veřejně uveden",
];

function TabContent({ activeTab }: { activeTab: string }) {
  const rowClass = "flex flex-col sm:flex-row sm:items-start gap-1 py-3 border-b border-[#eef1f7] last:border-0";
  const labelClass = "text-gray-500 text-sm sm:w-48 flex-shrink-0";
  const valueClass = "text-gray-900 text-sm font-medium leading-relaxed";

  if (activeTab === "platby") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Minimální vklad:</span><span className={valueClass}>250 Kč</span></div>
        <div className={rowClass}><span className={labelClass}>Minimální výběr:</span><span className={valueClass}>250 Kč</span></div>
        <div className={rowClass}><span className={labelClass}>Doba výběru:</span><span className={valueClass}>Až 3 pracovní dny</span></div>
        <div className={rowClass}><span className={labelClass}>Měs. limit výběru:</span><span className={valueClass}>Není veřejně uveden</span></div>
        <div className={rowClass}><span className={labelClass}>Metody vkladu:</span><span className={valueClass}>Bankovní převod, Trustly, Sofort, Visa, Mastercard, Maestro, Paysafecard, ecoVoucher, CashtoCode, Skrill, Neteller, MiFinity, EcoPayz, eZeeWallet, Apple Pay, Boku, Bitcoin, Ethereum, Litecoin, Ripple, Tether, USD Coin, Dogecoin, Cardano, Bitcoin Cash a další</span></div>
        <div className={rowClass}><span className={labelClass}>Metody výběru:</span><span className={valueClass}>Bankovní převod, Visa, Mastercard, Maestro, Skrill, Neteller, EcoPayz, Trustly</span></div>
      </div>
    );
  }
  if (activeTab === "hry") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Celkový počet her:</span><span className={valueClass}>9 000+</span></div>
        <div className={rowClass}><span className={labelClass}>Výherní automaty:</span><span className={valueClass}>8 500+</span></div>
        <div className={rowClass}><span className={labelClass}>Ruleta:</span><span className={valueClass}>100+ variant</span></div>
        <div className={rowClass}><span className={labelClass}>Blackjack:</span><span className={valueClass}>100+ variant</span></div>
        <div className={rowClass}><span className={labelClass}>Sportovní sázení:</span><span className={valueClass}>Ano – s vlastním bonusem</span></div>
        <div className={rowClass}><span className={labelClass}>Funkce Shorts:</span><span className={valueClass}>Ano – unikátní rychlý výběr her</span></div>
        <div className={rowClass}><span className={labelClass}>Pay N Play:</span><span className={valueClass}>Ano – okamžitý přístup bez registrace</span></div>
        <div className={rowClass}><span className={labelClass}>Klíčoví poskytovatelé:</span><span className={valueClass}>NetEnt, Play'n GO, Pragmatic Play, Evolution, Microgaming, Red Tiger, Nolimit City, Yggdrasil, Push Gaming, Quickspin, Ezugi, Hacksaw Gaming, ELK Studios a další</span></div>
      </div>
    );
  }
  if (activeTab === "podpora") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Dostupnost:</span><span className={valueClass}>24/7</span></div>
        <div className={rowClass}><span className={labelClass}>E-mail:</span><span className={valueClass}>support@spinit.com</span></div>
        <div className={rowClass}><span className={labelClass}>Čeština:</span><span className={valueClass}>Ano</span></div>
        <div className={rowClass}><span className={labelClass}>Jazyky podpory:</span><span className={valueClass}>Angličtina, Finština, Němčina, Polština, Italština, Maďarština, Norština, Portugalština, Španělština, Čeština, Francouzština</span></div>
      </div>
    );
  }
  if (activeTab === "obecne") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Rok spuštění:</span><span className={valueClass}>2026</span></div>
        <div className={rowClass}><span className={labelClass}>Provozovatel:</span><span className={valueClass}>7StarsPartners</span></div>
        <div className={rowClass}><span className={labelClass}>Licence:</span><span className={valueClass}>Anjouan</span></div>
        <div className={rowClass}><span className={labelClass}>Platformy:</span><span className={valueClass}>PC, mobilní prohlížeč (bez aplikace)</span></div>
        <div className={rowClass}><span className={labelClass}>Čeština:</span><span className={valueClass}>Ano</span></div>
        <div className={rowClass}><span className={labelClass}>Přijímané měny:</span><span className={valueClass}>Kč, USD, AUD, BRL, CAD, NOK, NZD, CHF, PLN, HUF, INR, PEN, ZAR, CLP a další</span></div>
        <div className={rowClass}><span className={labelClass}>Pay N Play:</span><span className={valueClass}>Ano – hrajte bez registrace</span></div>
        <div className={rowClass}><span className={labelClass}>Česká republika:</span><span className={valueClass}>Přístup povolen</span></div>
      </div>
    );
  }
  if (activeTab === "zodpovedne") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        {([
          ["Deposit limity:", "Nastavitelné v profilu"],
          ["Sebevyloučení:", "Ano"],
          ["Věková hranice:", "18+"],
          ["Licence:", "Anjouan (ne česká regulace MF ČR)"],
        ] as [string, string][]).map(([label, value]) => (
          <div key={label} className={rowClass}>
            <span className={labelClass}>{label}</span>
            <span className={valueClass}>{value}</span>
          </div>
        ))}
      </div>
    );
  }
  return null;
}

export default function SpinItPage() {
  useSEO({ title: "SPINiT Casino Recenze 2026 – Tisíce automatů a bonus | HrajBonus", description: "Recenze SPINiT Casino. Tisíce automatů, přehledné rozhraní a uvítací bonus pro nové hráče. Výplaty do 3 dnů. Hodnocení 8.8/10. 18+",
  url: "https://hrajbonus.com/kasina/spinit", });

  const [activeTab, setActiveTab] = useState("hry");

  return (
    <>
      <Header />
      <main className="bg-[#f7f9fd] min-h-screen pt-[64px]">

        {/* ── Hero ─────────────────────────────────────────── */}
        <div style={{ background: "linear-gradient(135deg, #001a4d 0%, #002d7c 50%, #003da5 100%)" }}>
          <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 py-10 sm:py-14">
            <div className="flex flex-col lg:flex-row lg:items-center gap-8 lg:gap-12">

              <div className="flex-1">
                <div className="flex items-center gap-6 mb-5">
                  <div className="w-[100px] h-[100px] rounded-xl flex-shrink-0 overflow-hidden shadow-lg">
                    <img src={logo17} alt="SPINiT Casino logo" className="w-full h-full object-cover" />
                  </div>
                  <div>
                    <div className="text-white/60 text-sm font-medium mb-0.5">Recenze kasina</div>
                    <h1 className="text-white font-bold text-2xl sm:text-3xl leading-tight">Recenze Kasina SPINiT</h1>
                    <div className="text-white/50 text-xs mt-0.5">Aktualizováno: 15/02/2026</div>
                  </div>
                </div>

                <div className="flex items-center gap-2 mb-5">
                  <div className="flex gap-0.5">
                    {[1,2,3,4].map(i => (
                      <Star key={i} className="w-5 h-5 fill-[#f5c518] text-[#f5c518]" />
                    ))}
                    <div className="relative w-5 h-5">
                      <Star className="w-5 h-5 text-[#f5c518]/30 absolute inset-0" />
                      <div className="overflow-hidden absolute inset-0" style={{ width: "50%" }}>
                        <Star className="w-5 h-5 fill-[#f5c518] text-[#f5c518]" />
                      </div>
                    </div>
                  </div>
                  <span className="text-white font-bold text-xl">9.0</span>
                  <span className="text-white/50 text-sm">/10</span>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                  {[
                    { label: "Celkem her",      value: "9 000+" },
                    { label: "Výherní automaty", value: "8 500+" },
                    { label: "Minimální vklad", value: "250 Kč" },
                    { label: "Spuštění",        value: "2026" },
                  ].map(s => (
                    <div key={s.label} className="bg-white/10 rounded-lg px-3 py-2.5 backdrop-blur-sm">
                      <div className="text-white/55 text-xs mb-0.5">{s.label}</div>
                      <div className="text-white font-bold text-sm">{s.value}</div>
                    </div>
                  ))}
                </div>

                <div className="flex flex-wrap gap-2 mt-4">
                  <span className="bg-white/15 text-white/90 text-xs font-semibold px-3 py-1 rounded-full">Funkce Shorts</span>
                  <span className="bg-white/15 text-white/90 text-xs font-semibold px-3 py-1 rounded-full">Pay N Play</span>
                  <span className="bg-white/15 text-white/90 text-xs font-semibold px-3 py-1 rounded-full">Non-sticky bonus</span>
                  <span className="bg-white/15 text-white/90 text-xs font-semibold px-3 py-1 rounded-full">Bonus Crab</span>
                  <span className="bg-white/15 text-white/90 text-xs font-semibold px-3 py-1 rounded-full">Apple Pay</span>
                </div>

                <div className="mt-3 text-white/50 text-xs font-medium">
                  Čeština dostupná · Přijímá Kč · Přístup z ČR povolen
                </div>
              </div>

              <div className="lg:w-[320px] bg-white/10 border border-white/20 rounded-2xl p-6 backdrop-blur-sm">
                <div className="text-center mb-4">
                  <div className="text-white/70 text-sm mb-1">Uvítací bonus (non-sticky)</div>
                  <div className="text-white font-black text-2xl leading-tight">až 12 500 Kč</div>
                  <div className="text-[#f5c518] font-bold text-lg">+ 200 free spinů + Bonus Crab</div>
                  <div className="text-white/50 text-xs mt-1">Wager 35× bonus · Wager 40× FS</div>
                </div>
                <a href={CASINO_URL} target="_blank" rel="sponsored noopener noreferrer" className="block">
                  <Button
                    className="hraj-btn w-full font-bold text-base py-3 gap-2"
                    data-testid="button-hero-cta"
                  >
                    Hraj <ArrowRight className="hraj-arrow w-4 h-4" />
                  </Button>
                </a>
                <p className="text-white/40 text-xs text-center mt-3 leading-relaxed">
                  18+ | Zodpovědné hraní | Platí podmínky
                </p>
              </div>
            </div>
          </div>
        </div>

                <CasinoBreadcrumb casinoName="SPINiT" />

<div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 py-8 sm:py-12">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-10">

            <div className="flex-1 min-w-0 space-y-8">

              {/* Author opinion */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm" data-testid="author-opinion">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0"><img src={mykhailoPhoto} alt="Mykhailo Romaenko" className="w-full h-full object-cover" /></div>
                  <div>
                    <div className="font-bold text-gray-900 text-sm">Mykhailo Romaenko</div>
                    <div className="text-gray-400 text-xs">Senior Content Writer</div>
                  </div>
                  <div className="ml-auto text-right">
                    <div className="text-[#003da5] font-black text-xl">9.0</div>
                    <div className="text-gray-400 text-xs">/10 hodnocení</div>
                  </div>
                </div>
                <h2 className="font-bold text-gray-900 text-base mb-2">Recenze Kasina SPINiT</h2>
                <p className="text-gray-600 text-sm leading-relaxed">
                  SPINiT je nejmladší kasino v naší databázi, spuštěné v roce 2026 pod skupinou 7StarsPartners. Vyznačuje se unikátním rozhraním s funkcí \u201eShorts\u201c pro intuitivní procházení her, více než 9 000 tituly, Pay N Play přístupem bez registrace a štědrým uvítacím balíčkem včetně Bonus Craba. Platforma je dostupná v češtině a přijímá koruny.
                </p>

                <div className="grid sm:grid-cols-2 gap-4 mt-5">
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-green-700 text-xs uppercase tracking-wide mb-2">
                      <CheckCircle className="w-3.5 h-3.5" /> Výhody
                    </div>
                    <ul className="space-y-1.5">
                      {pros.map(p => (
                        <li key={p} className="flex items-start gap-1.5 text-gray-700 text-sm">
                          <span className="text-green-500 font-bold mt-0.5 flex-shrink-0">+</span> {p}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-red-600 text-xs uppercase tracking-wide mb-2">
                      <XCircle className="w-3.5 h-3.5" /> Nevýhody
                    </div>
                    <ul className="space-y-1.5">
                      {cons.map(c => (
                        <li key={c} className="flex items-start gap-1.5 text-gray-700 text-sm">
                          <span className="text-gray-400 font-bold mt-0.5 flex-shrink-0">▬</span> {c}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>

              {/* Tabs */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] shadow-sm overflow-hidden" data-testid="casino-overview-tabs">
                <div className="px-5 pt-5 pb-0 border-b border-[#eef1f7]">
                  <h2 className="font-bold text-gray-900 text-base mb-4">Přehled kasina</h2>
                  <div className="flex gap-0 overflow-x-auto -mx-5 px-5">
                    {tabs.map(tab => (
                      <button
                        key={tab.id}
                        onClick={() => setActiveTab(tab.id)}
                        className={`flex items-center gap-1.5 px-3 py-2.5 text-xs font-semibold whitespace-nowrap border-b-2 transition-colors flex-shrink-0 ${
                          activeTab === tab.id
                            ? "border-[#003da5] text-[#003da5]"
                            : "border-transparent text-gray-500 hover:text-gray-700"
                        }`}
                        data-testid={`tab-${tab.id}`}
                      >
                        <tab.icon className="w-3.5 h-3.5" />
                        {tab.label}
                      </button>
                    ))}
                  </div>
                </div>
                <div className="p-5">
                  <TabContent activeTab={activeTab} />
                </div>
              </div>

              {/* Unique features */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-black text-gray-900 text-xl sm:text-2xl mb-4">Co dělá SPINiT výjimečným</h2>
                <p className="text-gray-600 leading-relaxed mb-5">
                  SPINiT vstoupilo na trh v roce 2026 s ambicí přinést moderní uživatelský zážitek do světa online kasin. Dva klíčové prvky jej odlišují od všech ostatních platforem: funkce \u201eShorts\u201c a Pay N Play.
                </p>

                <div className="grid sm:grid-cols-2 gap-4 mb-5">
                  <div className="bg-[#f0f5ff] border border-[#003da5]/20 rounded-xl p-4">
                    <div className="flex items-center gap-2 mb-2">
                      <Play className="w-5 h-5 text-[#003da5]" />
                      <div className="font-bold text-[#003da5] text-sm">Funkce \u201eShorts\u201c</div>
                    </div>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      Unikátní způsob procházení herního katalogu inspirovaný krátkými videovými formáty. Hráči mohou rychle procházet náhledy her a okamžitě spustit tu, která je zaujme – bez zdlouhavého filtrování.
                    </p>
                  </div>
                  <div className="bg-green-50 border border-green-200 rounded-xl p-4">
                    <div className="flex items-center gap-2 mb-2">
                      <Zap className="w-5 h-5 text-green-700" />
                      <div className="font-bold text-green-700 text-sm">Pay N Play</div>
                    </div>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      Funkce Pay N Play umožňuje okamžitý přístup ke hrám bez nutnosti klasické registrace. Stačí provést vklad a hrát – ideální pro hráče, kteří nechtějí ztrácet čas formuláři.
                    </p>
                  </div>
                </div>

                <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
                  {[
                    { label: "9 000+ her",          desc: "Největší katalog v naší nabídce" },
                    { label: "8 500+ automatů",     desc: "Absolutně nejvíce slotů" },
                    { label: "100+ ruleta",         desc: "Rozsáhlá sekce rulety" },
                    { label: "100+ blackjack",      desc: "Všechny varianty blackjacku" },
                  ].map(({ label, desc }) => (
                    <div key={label} className="bg-[#f3f6fb] rounded-xl p-3 text-center">
                      <div className="font-black text-[#003da5] text-base mb-0.5">{label}</div>
                      <div className="text-gray-500 text-xs">{desc}</div>
                    </div>
                  ))}
                </div>

                <div className="mt-4 bg-amber-50 border border-amber-300 rounded-xl p-4 flex gap-3">
                  <AlertTriangle className="w-5 h-5 text-amber-600 mt-0.5 flex-shrink-0" />
                  <p className="text-amber-700 text-sm leading-relaxed">
                    SPINiT provozuje svou činnost na základě licence Anjouan. Nejde o licenci vydanou Ministerstvem financí ČR – právní ochrana pro české hráče se proto liší od lokálně regulovaných operátorů.
                  </p>
                </div>
              </div>

              {/* Games & Providers */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Hry &amp; Poskytovatelé</h2>
                <div className="grid sm:grid-cols-2 gap-3 mb-4">
                  {[
                    ["Výherní automaty",  "8 500+ titulů – největší výběr automatů"],
                    ["Ruleta",            "100+ variant včetně živé rulety"],
                    ["Blackjack",         "100+ variant včetně živého blackjacku"],
                    ["Sportovní sázení",  "Ano – s vlastním uvítacím bonusem"],
                  ].map(([label, val]) => (
                    <div key={label} className="bg-[#f3f6fb] rounded-xl p-3">
                      <div className="font-semibold text-gray-900 text-xs mb-0.5">{label}</div>
                      <div className="text-gray-600 text-xs">{val}</div>
                    </div>
                  ))}
                </div>
                <div className="bg-[#f0f5ff] border border-[#003da5]/15 rounded-xl p-4">
                  <div className="font-bold text-[#003da5] text-xs mb-2">Populární poskytovatelé (100+)</div>
                  <div className="flex flex-wrap gap-1.5">
                    {["NetEnt", "Play'n GO", "Pragmatic Play", "Evolution", "Microgaming", "Red Tiger", "Nolimit City", "Yggdrasil", "Push Gaming", "Quickspin", "Ezugi", "Hacksaw Gaming", "ELK Studios"].map(p => (
                      <span key={p} className="bg-white border border-[#003da5]/15 text-gray-700 text-xs px-2.5 py-1 rounded-full font-medium">{p}</span>
                    ))}
                    <span className="text-gray-400 text-xs self-center">a mnoho dalších...</span>
                  </div>
                </div>
              </div>

              {/* Bonuses */}
              <div id="bonusy" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Bonusy &amp; Akce</h2>
                <p className="text-gray-600 leading-relaxed mb-5">
                  SPINiT nabízí uvítací balíček ve formě <strong>non-sticky (nelepivého) bonusu</strong> pro nové hráče – jak pro kasino, tak pro sportovní sázení. Součástí kasinového bonusu je i Bonus Crab.
                </p>

                <div className="grid sm:grid-cols-2 gap-4 mb-5">
                  <div className="bg-[#f0f5ff] border border-[#003da5]/20 rounded-xl p-4">
                    <div className="text-[#003da5] font-black text-lg mb-0.5">Casino bonus</div>
                    <div className="text-gray-900 font-bold text-base mb-1">100% až 12 500 Kč</div>
                    <div className="text-[#c9960f] font-bold text-sm mb-1">+ 200 free spinů</div>
                    <div className="text-[#c9960f] font-semibold text-sm mb-2">+ 1 Bonus Crab</div>
                    <div className="text-gray-400 text-xs space-y-0.5">
                      <div>Non-sticky · Wager 35× bonus</div>
                      <div>Wager 40× free spiny</div>
                    </div>
                  </div>
                  <div className="bg-[#f3f6fb] border border-[#dde4ee] rounded-xl p-4">
                    <div className="text-gray-700 font-bold text-lg mb-0.5">Sport bonus</div>
                    <div className="text-gray-900 font-bold text-base mb-1">100% až 2 500 Kč</div>
                    <div className="text-gray-500 text-sm mb-2">Na první vklad do sportovní sekce</div>
                    <div className="text-gray-400 text-xs">Non-sticky</div>
                  </div>
                </div>

                <div className="bg-green-50 border border-green-200 rounded-xl p-4">
                  <div className="font-bold text-green-800 text-sm mb-1.5">Co je non-sticky bonus?</div>
                  <p className="text-green-700 text-sm leading-relaxed">
                    U nelepivých bonusů jsou reálné výhry odděleny od bonusových prostředků. Pokud vyhrajete ze svého vlastního vkladu ještě před splněním wageru, tyto reálné výhry lze vybrat. Jde o výrazně hráč-přívětivější podmínky než u klasického sticky bonusu.
                  </p>
                </div>
              </div>

              {/* Payments */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Platební metody</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  SPINiT nabízí jeden z nejrozsáhlejších výběrů platebních metod – od Apple Pay a mobilních plateb po deset různých kryptoměn.
                </p>

                <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-5">
                  {[
                    { label: "Min. vklad",         value: "250 Kč" },
                    { label: "Min. výběr",         value: "250 Kč" },
                    { label: "Doba výběru",        value: "Až 3 prac. dny" },
                    { label: "Apple Pay",          value: "Dostupné" },
                    { label: "Kryptoměny",         value: "10+ variant" },
                    { label: "Měs. limit výběru",  value: "Neuvedeno" },
                  ].map(({ label, value }) => (
                    <div key={label} className={`rounded-xl p-3 ${label === "Měs. limit výběru" ? "bg-amber-50 border border-amber-200" : "bg-[#f3f6fb]"}`}>
                      <div className="text-gray-500 text-xs mb-0.5">{label}</div>
                      <div className={`font-bold text-xs ${label === "Měs. limit výběru" ? "text-amber-700" : "text-gray-900"}`}>{value}</div>
                    </div>
                  ))}
                </div>

                <div className="grid sm:grid-cols-3 gap-4">
                  <div className="bg-[#f3f6fb] rounded-xl p-4">
                    <div className="font-bold text-gray-900 text-xs mb-2">Karty &amp; Banky</div>
                    <div className="flex flex-wrap gap-1">
                      {["Visa", "Mastercard", "Maestro", "Trustly", "Sofort", "Bankovní převod"].map(m => (
                        <PaymentLogoPill key={m} name={m} />
                      ))}
                    </div>
                  </div>
                  <div className="bg-[#f3f6fb] rounded-xl p-4">
                    <div className="font-bold text-gray-900 text-xs mb-2">E-peněženky &amp; Mobil</div>
                    <div className="flex flex-wrap gap-1">
                      {["Skrill", "Neteller", "MiFinity", "EcoPayz", "Apple Pay", "Boku", "Paysafecard"].map(m => (
                        <PaymentLogoPill key={m} name={m} />
                      ))}
                    </div>
                  </div>
                  <div className="bg-[#f3f6fb] rounded-xl p-4">
                    <div className="font-bold text-gray-900 text-xs mb-2">Kryptoměny</div>
                    <div className="flex flex-wrap gap-1">
                      {["Bitcoin", "Ethereum", "Litecoin", "Ripple", "Tether", "USD Coin", "Dogecoin", "Cardano", "Bitcoin Cash"].map(m => (
                        <PaymentLogoPill key={m} name={m} />
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              {/* Support */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Zákaznická podpora</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Zákaznická podpora je dostupná 24/7 v rámci vícejazyčné podpory. Čeština je plně podporována.
                </p>
                <div className="grid sm:grid-cols-2 gap-3">
                  <div className="flex items-start gap-3 p-3 bg-green-50 border border-green-100 rounded-xl">
                    <MessageCircle className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-900 text-sm">Live chat</div>
                      <div className="text-green-600 text-xs">24/7 na webu</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3 p-3 bg-green-50 border border-green-100 rounded-xl">
                    <Mail className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-900 text-sm">E-mail</div>
                      <div className="text-green-600 text-xs">support@spinit.com</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Responsible gaming */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Zodpovědné hraní</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Hazardní hry jsou určeny pro zábavu. Vždy zůstaňte ve svých mezích a sázejte jen tolik, kolik si můžete dovolit prohrát.
                </p>
                <div className="grid sm:grid-cols-3 gap-2">
                  {[
                    "Nastavení vkladových limitů",
                    "Dočasné a trvalé sebevyloučení",
                    "Věková hranice 18+",
                  ].map(item => (
                    <div key={item} className="flex items-start gap-2 bg-[#f3f6fb] rounded-xl p-3">
                      <ShieldCheck className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" />
                      <span className="text-gray-700 text-xs leading-relaxed">{item}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Author bio */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm" data-testid="author-bio">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0 ring-4 ring-[#003da5]/10"><img src={mykhailoPhoto} alt="Mykhailo Romaenko" className="w-full h-full object-cover" /></div>
                  <div>
                    <div className="font-bold text-gray-900">Mykhailo Romaenko</div>
                    <div className="text-[#003da5] text-sm font-medium">Senior Content Writer</div>
                  </div>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Mykhailo je zkušený autor zaměřený na iGaming, který se dlouhodobě pohybuje v odvětví online hazardu. Má bohatou praxi v psaní článků, které propojují svět hráčů i profesionálů. Jeho specialitou je vytváření hlubokých analýz, přehledných recenzí a trendově orientovaného obsahu, který čtenářům přináší nejen zábavu, ale i znalosti.
                </p>
                <p className="text-gray-600 text-sm leading-relaxed mt-3">
                  Své texty staví na detailním výzkumu a praktické zkušenosti, díky čemuž pomáhá hráčům lépe se orientovat v prostředí online casin.
                </p>
              </div>

            </div>

            {/* ── Sticky sidebar ────────────────────────────── */}
            <aside className="lg:w-[300px] flex-shrink-0">
              <div className="lg:sticky lg:top-[84px] space-y-4">

                <div className="bg-white rounded-2xl border border-[#003da5]/25 shadow-[0_4px_24px_rgba(0,61,165,0.12)] p-5" data-testid="sidebar-cta">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 rounded-lg bg-[#f3f6fb] flex items-center justify-center overflow-hidden">
                      <img src={logo17} alt="SPINiT" className="w-full h-full object-cover" />
                    </div>
                    <div>
                      <div className="font-bold text-gray-900 text-sm">SPINiT Casino</div>
                      <div className="flex items-center gap-0.5">
                        {[1,2,3,4].map(i => <Star key={i} className="w-3 h-3 fill-[#f5c518] text-[#f5c518]" />)}
                        <div className="relative w-3 h-3">
                          <Star className="w-3 h-3 text-[#f5c518]/30 absolute inset-0" />
                          <div className="overflow-hidden absolute inset-0" style={{ width: "50%" }}>
                            <Star className="w-3 h-3 fill-[#f5c518] text-[#f5c518]" />
                          </div>
                        </div>
                        <span className="text-gray-600 text-xs ml-1">9.0/10</span>
                      </div>
                    </div>
                  </div>
                  <div className="text-center mb-4 bg-[#f3f6fb] rounded-xl py-3">
                    <div className="text-gray-500 text-xs mb-0.5">Uvítací bonus (non-sticky)</div>
                    <div className="text-[#003da5] font-black text-xl">až 12 500 Kč</div>
                    <div className="text-[#c9960f] font-bold text-sm">+ 200 FS + Bonus Crab</div>
                    <div className="text-gray-400 text-xs mt-0.5">Wager 35× bonus · 40× FS</div>
                  </div>
                  <a href={CASINO_URL} target="_blank" rel="sponsored noopener noreferrer" className="block">
                    <Button
                      className="hraj-btn w-full font-bold gap-2"
                      data-testid="button-sidebar-cta"
                    >
                      Hraj <ArrowRight className="hraj-arrow w-4 h-4" />
                    </Button>
                  </a>
                  <p className="text-gray-400 text-xs text-center mt-2">18+ | Platí podmínky</p>
                </div>

                <div className="bg-white rounded-2xl border border-[#dde4ee] p-5">
                  <div className="font-bold text-gray-900 text-sm mb-3">Rychlý přehled</div>
                  <div className="space-y-2.5">
                    {([
                      { icon: Calendar,   label: "Rok",             value: "2026" },
                      { icon: Globe,      label: "Provozovatel",    value: "7StarsPartners" },
                      { icon: Lock,       label: "Licence",         value: "Anjouan" },
                      { icon: Gamepad2,   label: "Celkem her",      value: "9 000+" },
                      { icon: Trophy,     label: "Automaty",        value: "8 500+" },
                      { icon: CreditCard, label: "Min. vklad",      value: "250 Kč" },
                      { icon: Zap,        label: "Výplaty",         value: "Až 3 prac. dny" },
                      { icon: Play,       label: "Shorts & P'n'P",  value: "Ano" },
                      { icon: Smartphone, label: "Apple Pay",       value: "Dostupné" },
                    ] as const).map(({ icon: Icon, label, value }) => (
                      <div key={label} className="flex items-start gap-2">
                        <Icon className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" />
                        <div className="min-w-0">
                          <span className="text-gray-400 text-xs">{label}: </span>
                          <span className="text-gray-800 font-medium text-xs">{value}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="bg-[#f0f5ff] border border-[#003da5]/20 rounded-xl p-4">
                  <div className="font-bold text-[#003da5] text-xs mb-1.5">Nové v roce 2026</div>
                  <p className="text-[#003da5]/80 text-xs leading-relaxed">
                    SPINiT je nejmladší kasino v naší databázi. Díky funkci Shorts a Pay N Play přináší moderní přístup k online hraní.
                  </p>
                </div>

              </div>
            </aside>

          </div>
        </div>
      </main>
      
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 pb-8">
          <DalsiRecenze currentSlug="spinit" />
        </div>

  
        {/* Related reviews */}
        <div className="max-w-[900px] mx-auto px-4 py-4">
          <p className="text-sm text-gray-500 leading-relaxed text-center">
            <span className="font-semibold text-gray-700">Podobná kasina: </span>
              <a href="/kasina/wazamba" className="text-[#003da5] hover:underline" data-testid="review-link-wazamba">Wazamba</a>
              {" · "}
              <a href="/kasina/casinia" className="text-[#003da5] hover:underline" data-testid="review-link-casinia">Casinia</a>
              {" · "}
              <a href="/kasina/librabet" className="text-[#003da5] hover:underline" data-testid="review-link-librabet">Librabet</a>
            {" · "}
            <a href="/kasina" className="text-[#003da5] hover:underline font-semibold" data-testid="review-link-vsechna">Všechna kasina</a>
            {" · "}
            <a href="/porovnat" className="text-[#003da5] hover:underline" data-testid="review-link-porovnat">Porovnání</a>
          </p>
        </div>
      <Footer />
    </>
  );
}
